<div>

  <section class="form-tasklist">
    <mat-accordion class="retrofit-headers-align">
      <!--Sg-->
      <mat-expansion-panel *ngIf="this.steps.sg.show()" id="sg-panel"
        [expanded]="this.steps.sg.expanded()" (opened)="setApprovalTask('sg')">
        <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
          <mat-panel-title>
            <div *ngIf="isSgWaitList">
              <mat-icon class="retrofit-task-icon primary">error</mat-icon>

            </div>
            <div *ngIf="!isSgWaitList">
              <div *ngIf="taskSG.statusCode ===700000000 && application.sGStatus ===700000002">
                <mat-icon class="retrofit-task-icon primary"><i class="fa-solid fa-square-1 fa-sm"></i></mat-icon>

              </div>
              <div *ngIf="taskSG.statusCode ===700000003 && !application.envelopeOkToVerify && application.sGStatus ===700000002 ">
                <mat-icon class="retrofit-task-icon primary"><i class="fa-solid fa-square-1 fa-sm"></i></mat-icon>
              </div>
              <div *ngIf="taskSG.statusCode ===700000003 && application.envelopeOkToVerify  && application.sGStatus ===700000002">
                <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
              </div>
              <div *ngIf="application.sGStatus ===700000003">
                <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-circle-exclamation fa-sm "></i></mat-icon>
              </div>
              <div *ngIf="application.sGStatus ===700000004">
                <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
              </div>
              <div *ngIf="application.sGStatus ===700000002 && taskSG.statusCode ===700000002">
                <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
              </div>
              <div *ngIf="application.sGStatus ===700000002 && taskSG.statusCode ===700000001">
                <mat-icon class="retrofit-task-icon primary"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
              </div>
            </div>
            <div>
              <div class="retrofit-task-name">Supplemental Grant</div>
              <small class="retrofit-task-status" *ngIf="application.sGStatus !==700000003 && application.sGStatus !==700000004 ">
                {{ sgheadingstatus }} </small>

              <small class="retrofit-task-status" style="color:#c3391d ;" *ngIf="application.sGStatus ===700000003 "> {{ sgheadingstatus }} </small>
              <small class="retrofit-task-status" style="color:#2a7f48 ;" *ngIf="application.sGStatus ===700000004"> {{ sgheadingstatus }} </small>

            </div>
          </mat-panel-title>
          <mat-panel-description fxShow.gt-sm="true" fxShow="false">
            <span class="retrofit-task-summary todo">
              {{ 'Low-to-moderate income assessment' }}
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="retrofit-task-body" [ngClass]="{ disabledDiv: isreadonly }">
          <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
            <div fxFlex="75%">
              <!-- Sg WaitList -->
              <div *ngIf="application && isHomeowner() && isSgWaitList">

                <div class="retrofit-form-text">
                  <div [innerHTML]="textSGMessage"></div>
                </div>
                <br />
                <mat-checkbox class="retrofit-form-text" id="confirmReviewedTerms" name="confirmReviewedTerms"
                  (change)="onWithChangeEventTerms($event)">
                  <p>
                    I acknowledge that I will be removed from the Supplemental Grant wait list.
                  </p>
                </mat-checkbox>
                <div style="margin-top: 18px;" class="retrofit-form-text">
                  <button mat-raised-button style="white-space: pre-wrap !important;" color="primary" [disabled]="!withdrawagreeToTerms"
                    (click)="onwithdrawSG()">
                    WITHDRAW FROM WAIT LIST
                  </button>
                </div>
              </div>
              <!-- Sg Self Eligible, Qualified,Not Qualified -->
              <div *ngIf="isHomeowner() && !isSgWaitList">

                <p class="retrofit-task-item-title">Income Assessment</p>

                <div class="retrofit-form-text">
                  <div [innerHTML]="textSGMessage"></div>
                </div>


                <br>
                <ebb-portal-tax-list
                  [context]="'PreRetrofit'"
                  [title]="'Income Verification Requests'"
                  [application]="application"
                  [task]="taskSG"
                  [email]="email"
                  (onEmitOpenDocuUrlEvent)="onEmitOpenDocuUrl($event)"
                  (resubmitTaxRequestDataEvent)="onEmitResubmitTaxRequestData($event)"
                  (anyRejected4506cItemsDisplayedEvent)="onEmitAnyRejected4506cItemsDisplayed($event)"
                  (submitTaxRequestDataEvent)="onEmitsubmitTaxRequestData($event)"
                  (ondeleteIVR)="onIVRChange($event)"
                >
                </ebb-portal-tax-list>
                <br>
                <div *ngIf="formAutoSave" style="display: block; margin-top: 12px;">
                  <mat-progress-bar mode="indeterminate" style="width: 300px;">
                  </mat-progress-bar>
                </div>
                <div *ngIf="application.sGStatus ===700000002 ">
                  <div class="retrofit-form-text" *ngIf="(this.sg4506cCount >= this.application.sGmaxrequests && !application.envelopeOkToVerify) || (this.sg4506cCount + this.sg4506cRejectedCount >= this.application.sGmaxrequests && this.sg4506cRejected)">
                    <div [innerHTML]="sgmax4506climtmsg"></div>
                  </div>
                  <div style="margin-top: 18px;" class="retrofit-form-text" [ngClass]="{disabledDiv: this.disableSgSubmitButton}">
                    <div *ngIf="!application.envelopeOkToVerify">
                      <button mat-stroked-button color="primary" class="button-wrap" (click)="onClickSubmitTaxRequestData()">
                        <mat-icon>add</mat-icon>
                        <span *ngIf="taskSG.approvalTaskItems.length ===0">SUBMIT INCOME VERIFICATION FORM</span>
                        <span *ngIf="taskSG.approvalTaskItems.length !==0">SUBMIT ANOTHER INCOME VERIFICATION FORM</span>
                      </button>
                    </div>
                  </div>
                  <br>
                  <div class="retrofit-form-text" *ngIf="!application.envelopeOkToVerify">
                    <div [innerHTML]="incomeverificationsubmit"></div>
                  </div>
                  <br>
                  <div *ngIf="!application.envelopeOkToVerify" [ngClass]="{disabledDiv: taskSG.statusCode !== 700000003 }">

                    <mat-checkbox class="retrofit-form-text" id="SubmitChangeReviewedTerms" name="SubmitChangeReviewedTerms"
                      (change)="onSubmitChangeEventTerms($event)">
                      <p>
                        I verify that an IVF request has been completed for all income-earners in the household.
                      </p>
                    </mat-checkbox>

                    <div style="margin-top: 18px;">
                      <button mat-raised-button color="primary" [disabled]="!submitdrawagreeToTerms" (click)="onClickTaxIncomeSubmit()">
                        SUBMIT INCOME ASSESSMENT
                      </button>
                    </div>
                  </div>

                </div>
                <div class="retrofit-form-text" *ngIf="application.sGStatus ===700000004">
                  <div class="retrofit-form-sg-message-qualified" [innerHTML]="sgqualifiedstatusmsg"></div>
                </div>

                <div class="retrofit-form-text" *ngIf="application.sGStatus ===700000003">
                  <div class="retrofit-form-sg-message-notqualified" [innerHTML]="sgnotqualifiedstatusmsg"></div>

                </div>

              </div>
            </div>
            <div fxFlex="25%">
              <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

              <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

              <div div *ngFor="let helpLink of helpByTopic('sg')">
                <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                  {{ helpLink.linkText }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <!--Contractor info-->
      <mat-expansion-panel *ngIf="this.steps.contractor.show()" id="contractor-info-panel" 
        [expanded]="this.steps.contractor.expanded()" (opened)="setApprovalTask('contractor')">
        <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
          <mat-panel-title>
           
            <div [ngSwitch]="taskRetrofitContractorStatus.toLowerCase()">
              
              <mat-icon *ngSwitchCase="'pending'" class="retrofit-task-icon primary">
                <div [innerHTML]="loadTaskStatusIconHtml('contractor', taskRetrofitContractorStatus)"></div>
               </mat-icon>
              <mat-icon *ngSwitchCase="'permission'" class="retrofit-task-icon primary">  <div [innerHTML]="loadTaskStatusIconHtml('contractor', taskRetrofitContractorStatus)"></div></mat-icon>
              <mat-icon *ngSwitchCase="'estimate'" class="retrofit-task-icon primary">  <div [innerHTML]="loadTaskStatusIconHtml('contractor', taskRetrofitContractorStatus)"></div></mat-icon>
        
              <mat-icon *ngSwitchCase="'selected'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
              <mat-icon *ngSwitchCase="'rejected'" class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
              <mat-icon *ngSwitchCase="'updated'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
            </div>
            <div>
              <div class="retrofit-task-name">{{taskRetrofitContractorTitle}}</div>
              <span [ngSwitch]="taskRetrofitContractorStatus.toLowerCase()">
                <small class="retrofit-task-status" *ngSwitchCase="'pending'">
                  Waiting for selection
                </small>
                <small class="retrofit-task-status" *ngSwitchCase="'permission'">
                  Waiting for permission
                </small>
                <small class="retrofit-task-status" *ngSwitchCase="'estimate'">
                  Waiting for estimate
                </small>
                <!-- <small class="retrofit-task-status" *ngSwitchCase="'invoice'">
                  Waiting for bid invoice
                </small> -->
                <small class="retrofit-task-status" *ngSwitchCase="'rejected'">
                  Action required
                </small>
                <small class="retrofit-task-status accepted" *ngSwitchCase="'selected'">
                  Completed
                </small>
                <small class="retrofit-task-status" *ngSwitchDefault>
                  {{taskRetrofitContractorStatus}}
                </small>
              </span>
            </div>
          </mat-panel-title>
          <mat-panel-description fxShow.gt-sm="true" fxShow="false">
            <span class="retrofit-task-summary todo">
              {{taskRetrofitContractorSummary}}
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
          <div fxLayout="row" fxLayout.lt-md="column wrap">
            <div fxFlex='75%'>
              <ebb-portal-contractor-form [application]="application"
                [taskBuildingPermit]="taskBuildingPermit"
                [taskSG]="taskSG"
                [w9Shown]="this.steps.w9.show()"
                (emitContractorUpdateEvent)="onEmitContractorUpdate($event)"
                (emitContractorFileUploadEvent)="onEmitContractorFileUploadEvent($event)"
                (emitBidInvoiceFileUploadEvent)="onEmitBidInvoiceFileUploadEvent($event)"
                (emitBidInvoiceInitEvent)="onEmitBidInvoiceInitEvent($event)">
              </ebb-portal-contractor-form>
            </div>

            <div fxFlex='25%'>
              <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
                Help
              </p>

              <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

              <div *ngFor="let helpLink of helpByTopic('construction')">
                <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                  {{helpLink.linkText}}
                </a>
              </div>
            </div>
          </div>
        </div>

      </mat-expansion-panel>
         <!--W-9 form-->
    <mat-expansion-panel *ngIf="this.steps.w9.show()" id="w9-panel" 
         [expanded]="this.steps.w9.expanded()" (opened)="setApprovalTask('w9')">
         <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
           <mat-panel-title>
             
             <mat-icon class="retrofit-task-icon"  [ngClass]="{'accepted':
                                 (taskW9form.statusCode === 700000001 || taskW9form.statusCode === 700000003),
                               'rejected': taskW9form.statusCode === 700000002,
                               'primary': true  }">
                               <div [innerHTML]="loadTaskStatusIconHtml('w9', taskW9form.statusCode)"></div>
                                             
             </mat-icon>
             <div>
               <div class="retrofit-task-name">{{taskW9form.name}}</div>
               <small [ngClass]="{'retrofit-task-status accepted': taskW9form.statusCode === 700000001,
                     'retrofit-task-status': true}">
                 {{loadTaskStatusValue('w9', taskW9form.statusCode)}}
               </small>
             </div>
           </mat-panel-title>
           <mat-panel-description fxShow.gt-sm="true" fxShow="false">
             <span *ngIf="!w9FormSubmitted" class="retrofit-task-summary todo">
               {{taskW9form.userPrompt}}
             </span>
             <span *ngIf="w9FormSubmitted" class="retrofit-task-summary todo">
               {{w9FormPayee}} W-9 data (uploaded)
             </span>
           </mat-panel-description>
         </mat-expansion-panel-header>
         <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
           <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
             <div fxFlex='75%'>
 
               <div *ngIf="!isContractor()">
                 <p class="retrofit-task-item-title">W-9 information</p>
                 <div class="retrofit-form-text">
                   <div [innerHTML]="w9message"></div>
                 </div>
                 <div style="margin-top: 18px;" *ngIf="enableW9Form()">
                   <button mat-raised-button color="primary" (click)="onClickSubmitW9data()">
                     COMPLETE W-9 FORM
                   </button>
                 </div>
 
                 <div style="margin-top: 18px" *ngIf="taskW9form.approvalTaskItems[0].statusCode === 700000002
                             && (taskW9form.approvalTaskItems[0].reasonWhy
                                 && taskW9form.approvalTaskItems[0].reasonWhy.length > 0)">
                   <p><span class="warn-text">Action required</span>: {{taskW9form.approvalTaskItems[0].reasonWhy}}</p>
                 </div>
 
                 <div class="retrofit-form-inline-icon-with-label-container" *ngIf="w9FormSubmitted">
                   <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">check_circle_outline</mat-icon>
                   <span class="retrofit-form-inline-icon-with-label-text">{{w9FormPayee}} W-9 data submitted on
                     {{w9AuthorizationDate | date: 'M/d/yyyy'}}</span>
                 </div>
               </div>
 
               <div *ngIf="isContractor()">
                 <p>
                   This section must be completed by homeowner.
                 </p>
               </div>
 
             </div>
 
             <div fxFlex='25%'>
               <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
 
               <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
 
               <div div *ngFor="let helpLink of helpByTopic('payment')">
                 <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                   {{helpLink.linkText}}
                 </a>
               </div>
             </div>
           </div>
         </div>
    </mat-expansion-panel>
 
    <!-- Sg Bid Invoice -->
    <mat-expansion-panel *ngIf="this.steps.bidinvoice.show()" id="sgbidinvoice-panel"
      [expanded]="this.steps.bidinvoice.expanded()" (opened)="setApprovalTask('bidinvoice')">
      <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
        <mat-panel-title>
    
          <div [ngSwitch]="taskRetrofitbidInvoiceStatus.toLowerCase()">
    
            <mat-icon *ngSwitchCase="'pending'" class="retrofit-task-icon primary">
              <div [innerHTML]="loadTaskStatusIconHtml('bidinvoice', 0)"></div>
            </mat-icon>
              
            <mat-icon *ngSwitchCase="'invoice'" class="retrofit-task-icon primary"> <div [innerHTML]="loadTaskStatusIconHtml('bidinvoice', 0)"></div></mat-icon>
            <mat-icon *ngSwitchCase="'selected'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
            <mat-icon *ngSwitchCase="'rejected'" class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
            <mat-icon *ngSwitchCase="'updated'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
            <mat-icon *ngSwitchCase="'approved'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
          </div>
    
          <div>
            <div class="retrofit-task-name">Bid Invoice</div>
    
            <span [ngSwitch]="taskRetrofitbidInvoiceStatus.toLowerCase()">
              <small class="retrofit-task-status" *ngSwitchCase="'pending'">
                Waiting for selection
              </small>
    
              <small class="retrofit-task-status" *ngSwitchCase="'invoice'">
                Waiting for bid invoice
              </small>
              <small class="retrofit-task-status" *ngSwitchCase="'rejected'">
                Action required
              </small>
              <small class="retrofit-task-status accepted" *ngSwitchCase="'selected'">
                Completed
              </small>
              <small class="retrofit-task-status accepted" *ngSwitchCase="'approved'">
                Approved
              </small>
    
            </span>
          </div>
        </mat-panel-title>
        <mat-panel-description fxShow.gt-sm="true" fxShow="false">
          <span class="retrofit-task-summary todo">
            Invoice for receving a bid
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
        <div fxLayout="row" fxLayout.lt-md="column wrap">
          <div fxFlex='75%'>
            <div *ngIf="!isContractor()">
            <ebb-portal-contractor-sg-form *ngIf="isSgQualify()" [application]="application" [taskSG]="taskSG"
              [w9Shown]="w9Shown" (emitFileUploadEvent)="onEmitBidInvoiceFileUploadEvent($event)"
              (emitBidInvoiceApplicationChangeEvent)="onEmitBidInvoiceApplicationChangeEvent($event)"
              (emitBidInvoiceChoiceEvent)="onEmitBidInvoiceChoiceEvent($event)">
            </ebb-portal-contractor-sg-form>
            </div>  
            <div *ngIf="isContractor()">
              <p>
                This section must be completed by homeowner.
              </p>
            </div>
          </div>
    
          <div fxFlex='25%'>
            <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
              Help
            </p>
    
            <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
    
            <div *ngFor="let helpLink of helpByTopic('Sgbidinvoice')">
              <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                {{helpLink.linkText}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Sg Permit Receipt -->
    <mat-expansion-panel *ngIf="this.steps.permitreceipt.show()" id="sgpermitreceipt-panel"
      [expanded]="this.steps.permitreceipt.expanded()" (opened)="setApprovalTask('permitreceipt')">
      <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
        <mat-panel-title>
    
          <div [ngSwitch]="taskRetrofitPermitReceipteStatus.toLowerCase()">
    
            <mat-icon *ngSwitchCase="'pending'" class="retrofit-task-icon primary">
              <div [innerHTML]="loadTaskStatusIconHtml('permitreceipt', 0)"></div>
            </mat-icon>
              
            <mat-icon *ngSwitchCase="'permitreceipt'" class="retrofit-task-icon primary"> <div [innerHTML]="loadTaskStatusIconHtml('permitreceipt', 0)"></div></mat-icon>
            <mat-icon *ngSwitchCase="'selected'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
            <mat-icon *ngSwitchCase="'rejected'" class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
            <mat-icon *ngSwitchCase="'updated'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
            <mat-icon *ngSwitchCase="'approved'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
          </div>
    
          <div>
            <div class="retrofit-task-name">Permit Receipt</div>
    
            <span [ngSwitch]="taskRetrofitPermitReceipteStatus.toLowerCase()">
              <small class="retrofit-task-status" *ngSwitchCase="'pending'">
                Waiting for information
              </small>
    
              <small class="retrofit-task-status" *ngSwitchCase="'permitreceipt'">
                Waiting for permit receipt
              </small>
              <small class="retrofit-task-status" *ngSwitchCase="'rejected'">
                Action required
              </small>
              <small class="retrofit-task-status accepted" *ngSwitchCase="'selected'">
                Completed
              </small>
              <small class="retrofit-task-status accepted" *ngSwitchCase="'approved'">
                Approved
              </small>
    
            </span>
          </div>
        </mat-panel-title>
        <mat-panel-description fxShow.gt-sm="true" fxShow="false">
          <span class="retrofit-task-summary todo">
            Permit Receipt
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
        <div fxLayout="row" fxLayout.lt-md="column wrap">
          <div fxFlex='75%'>
            <div *ngIf="!isContractor()">
            <ebb-portal-permitreceipt-sg-form *ngIf="isSgQualify()" [application]="application" [taskSG]="taskSG"
              [w9Shown]="w9Shown" (emitFileUploadEvent)="onEmitPermitReceiptFileUploadEvent($event)"
              (emitPermitReceiptApplicationChangeEvent)="onEmitPermitReceiptApplicationChangeEvent($event)"
              (emitPermitReceiptChoiceEvent)="onEmitPermitReceiptChoiceEvent($event)">
            </ebb-portal-permitreceipt-sg-form>
          </div>
            <div *ngIf="isContractor()">
              <p>
                This section must be completed by homeowner.
              </p>
            </div>
          </div>
    
          <div fxFlex='25%'>
            <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
              Help
            </p>
    
            <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
    
            <div *ngFor="let helpLink of helpByTopic('Sgpermitreceipt')">
              <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                {{helpLink.linkText}}
              </a>
            </div>
          </div>
        </div>
      </div>
</mat-expansion-panel>
   
      <!--Permit info-->
      <mat-expansion-panel *ngIf="this.steps.permit.show() && getPermitStatus() as permitStatusCode" id="permit-info-panel" 
        [expanded]="this.steps.permit.expanded()" (opened)="setApprovalTask('permit')">
        <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
          <mat-panel-title>
             <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                              ((permitStatusCode === 700000001 || permitStatusCode === 700000003) && !waitingForPermitInfo) ||
                              (permitStatusCode === 700000002 && onlyEstimateIsRejected === true),
                              'rejected': 
                              (permitStatusCode === 700000002 && onlyEstimateIsRejected === false),
                              'primary': 
                              true  }">
                              
                              <div [innerHTML]="loadTaskStatusIconHtml('permit', permitStatusCode)"></div>
              
            </mat-icon>
            <div>
              <div class="retrofit-task-name">{{taskBuildingPermit.name}}</div>
              <small [ngClass]="{'retrofit-task-status accepted': getPermitStatus() === 700000001 && !waitingForPermitInfo,
                                'retrofit-task-status': true}">
                {{loadTaskStatusValue('permit', getPermitStatus())}}
              </small>
            </div>
          </mat-panel-title>
          <mat-panel-description fxShow.gt-sm="true" fxShow="false">
            <span class="retrofit-task-summary todo">
              <span *ngIf="!application.permitIssuer">
                {{taskBuildingPermit.userPrompt}}
              </span>
              <span *ngIf="application.permitIssuer && application.permitIssuer.length > 0">
                {{application.permitIssuer}} ({{application.permitNumber}})
              </span>
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
          <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
            <div fxFlex='75%'>

              
              <div class="retrofit-form-text">
                <div [innerHTML]="textBuildingPermitMessage"></div>
              </div>
              <br />

              <p class="retrofit-task-item-title">Permit Documents</p>
              <ebb-portal-file-list [context]="'PreRetrofit'" [title]="'Building Permit Files'" [application]="application"
                [task]="taskBuildingPermit" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
              </ebb-portal-file-list>

              <form [formGroup]="addPermitInfo" *ngIf="canAddPermitInfo()">
                <mat-form-field appearance="outline" md-no-float style="width:100%; max-width: 300px; margin-top: 1em;">
                  <mat-label style="color: #377491; font-weight: 500; text-transform: uppercase;">
                    UPLOAD ADDITIONAL DOCUMENTATION
                  </mat-label>
                  <mat-select (selectionChange)="onPermitAddChange($event)" id="permitType" name="permitType" formControlName="permitType">                  
                    <mat-option *ngFor="let item of additionalPermitOptions" [value]="item.label">{{ item.label }}</mat-option>
                  </mat-select>

               
                </mat-form-field>
              </form>

              <div *ngIf="progressSaveOptionalPermitDoc" style="margin-top: 12px;">
                <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
              </div>

              <ebb-portal-permit-form
                [application]="application"
                [task]="taskBuildingPermit"
                [permitPlanTypeOptions]="filteredPermitPlanTypeOptions"
                [saveButtonLabel]="IsSGApplication === true ? 'SAVE & SUBMIT' : 'SAVE'"
                [isDisabled]="disableBuildingPermitForm()"
                (emitPermitInfoChangeEvent)="onEmitPermitUpdate($event)">
              </ebb-portal-permit-form>
            </div>

            <div fxFlex='25%'>
              <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

              <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

              <div div *ngFor="let helpLink of helpByTopic('permit')">
                <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                  {{helpLink.linkText}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <!--House photos-->
      <mat-expansion-panel *ngIf="this.steps.house.show()" id="house-photos-panel" 
        [expanded]="this.steps.house.expanded()" (opened)="setApprovalTask('house')">
        <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
          <mat-panel-title>
            <mat-icon class="retrofit-task-icon" [ngClass]="{'accepted':
                                (taskHousePhotos.statusCode === 700000001 || taskHousePhotos.statusCode === 700000003),
                              'rejected': taskHousePhotos.statusCode === 700000002,
                              'primary': true}">
                              <div [innerHTML]="loadTaskStatusIconHtml('house', taskHousePhotos.statusCode)"></div>
           
            </mat-icon>
            <div>
              <div class="retrofit-task-name">{{taskHousePhotos.name}}</div>
              <small [ngClass]="{'retrofit-task-status accepted': taskHousePhotos.statusCode === 700000001,
                                'retrofit-task-status': true}">
                {{loadTaskStatusValue('house', taskHousePhotos.statusCode)}}
              </small>
            </div>
          </mat-panel-title>
          <mat-panel-description fxShow.gt-sm="true" fxShow="false">
            <span class="retrofit-task-summary todo">
              {{taskHousePhotos.userPrompt}}
              <span *ngIf="taskHousePhotos.statusCode === 700000001 || taskHousePhotos.statusCode === 700000003" class="retrofit-task-summary todo">
                (uploaded)
              </span>
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
          <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
            <div fxFlex='75%'>

              
              <ebb-portal-photos [application]="application" [task]="taskHousePhotos" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
              </ebb-portal-photos>

            </div>

            <div fxFlex='25%'>
              <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

              <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

              <div div *ngFor="let helpLink of helpByTopic('photos')">
                <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                  {{helpLink.linkText}}
                </a>
              </div>

            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <!--Crawl space photos-->
      <mat-expansion-panel *ngIf="this.steps.crawlSpace.show()" id="crawlspace-info-panel"
        [expanded]="this.steps.crawlSpace.expanded()" (opened)="setApprovalTask('crawlSpace')">
        <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
          <mat-panel-title>
            <mat-icon class="retrofit-task-icon" [ngClass]="{'accepted':
                                (taskCrawlspacePhotos.statusCode === 700000001 || taskCrawlspacePhotos.statusCode === 700000003),
                              'rejected': taskCrawlspacePhotos.statusCode === 700000002,
                              'primary': true }">
                              <div [innerHTML]="loadTaskStatusIconHtml('crawlSpace', taskCrawlspacePhotos.statusCode)"></div>
              
            </mat-icon>
            <div>
              <div class="retrofit-task-name">{{taskCrawlspacePhotos.name}}</div>
              <small [ngClass]="{'retrofit-task-status accepted': taskCrawlspacePhotos.statusCode === 700000001,
                    'retrofit-task-status': true}">
                {{loadTaskStatusValue('crawlSpace', taskCrawlspacePhotos.statusCode)}}
              </small>
            </div>
          </mat-panel-title>
          <mat-panel-description fxShow.gt-sm="true" fxShow="false">
            <span class="retrofit-task-summary todo">
              {{taskCrawlspacePhotos.userPrompt}}
              <span *ngIf="taskCrawlspacePhotos.statusCode === 700000001 || taskCrawlspacePhotos.statusCode === 700000003"
                class="retrofit-task-summary todo">
                (uploaded)
              </span>
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
          <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
            <div fxFlex='75%'>

        
              <ebb-portal-photos [application]="application" [task]="taskCrawlspacePhotos" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
              </ebb-portal-photos>

            </div>

            <div fxFlex='25%'>
              <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

              <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

              <div div *ngFor="let helpLink of helpByTopic('photos')">
                <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                  {{helpLink.linkText}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      

            <!--receipts info-->
            <mat-expansion-panel *ngIf="this.steps.receipt.show()" id="receipts-info-panel" 
            [expanded]="this.steps.receipt.expanded()" (opened)="setApprovalTask('receipt')">          
            <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
              <mat-panel-title>
                <mat-icon class="retrofit-task-icon"
                [ngClass]="{'accepted':
                            ((taskReceipts.statusCode === 700000001 || taskReceipts.statusCode === 700000003) && !waitingForReceiptInfo),
                            'rejected': 
                            (taskReceipts.statusCode === 700000002),
                            'primary': 
                            true  }">
                            
                            <div [innerHTML]="loadTaskStatusIconHtml('receipt', taskReceipts.statusCode)"></div>       

</mat-icon>
                <div>
                  <div class="retrofit-task-name">{{taskReceipts.name}}</div>
                  <small [ngClass]="{'retrofit-task-status accepted': taskReceipts.statusCode === 700000001,
                        'retrofit-task-status': true}">
                    {{loadTaskStatusValue('receipt', taskReceipts.statusCode)}}
                  </small>
                </div>
              </mat-panel-title>
              <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                <span class="retrofit-task-summary todo">
                  {{taskReceipts.userPrompt}}
                  <span *ngIf="taskReceipts.statusCode === 700000001 || taskReceipts.statusCode === 700000003"
                    class="retrofit-task-summary todo">
                    (uploaded)
                  </span>
                </span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
              <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
                <div fxFlex='75%'>
    
                  
              
    
                  <p class="retrofit-task-item-title">Retrofit Receipts</p>
                  <ebb-portal-file-list [context]="'PreRetrofit'" [title]="'Retrofit Receipts'" [application]="application"
                    [task]="taskReceipts" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                  </ebb-portal-file-list>
    
                  <ebb-portal-receipt-preretrofit-form
                  [application]="application"
                  [task]="taskReceipts"
                            
                  (emitReceiptPreretrofitFormChangeEvent)="onEmitReceiptPreretrofitFormUpdate($event)">
                </ebb-portal-receipt-preretrofit-form>
                </div>
    
                <div fxFlex='25%'>
                  <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
    
                  <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
    
                  <div div *ngFor="let helpLink of helpByTopic('receipts')">
                    <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
    </mat-accordion>
  </section>

  <br />

</div>
